<template>
    <div class="featured-vertical-list" v-bind:style="leftColStyles">
        <div v-if="this.nearestOffers && this.nearestOffers.length">
            <div v-for="(item, index) in this.nearestOffers" :key="item.OfferId+index">
                <featured-map-data-view-component :offerNumber=index+1  :key="item.OfferId" :offer="item"></featured-map-data-view-component>
            </div>
        </div>
        <div v-else class="p-3">
            No data to display
        </div>
    </div>
</template>

<script>
import FeaturedMapDataViewComponent from "./FeaturedMapDataViewComponent.vue";
export default {
  name: "FeaturedVerticalListComponent",
  components: { FeaturedMapDataViewComponent },
  props: ['nearestOffers'],
  data() {
    return {
      leftColStyles: {},
    };
  },
  methods: {
    /* matchHeight() {
      var heightString = this.$refs.infoBox.clientHeight + "px";
      Vue.set(this.leftColStyles, "height", heightString);
    }, */
  },
  mounted() {
    //this.matchHeight();
    // console.log(this.featuredOffers);
  },
};
</script>

<style>
</style>
